import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { StyledDotLoader } from './DotLoader.styles.js';

const DotLoader = forwardRef((props, ref) => {
    return jsx(StyledDotLoader, Object.assign({}, props));
});

export { DotLoader as default };
//# sourceMappingURL=DotLoader.js.map
